import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
import { db } from '../../db/db-dexie'
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }

const SubAccountService = {
    async Get() { return await methods.Get("SubAccount/Get"); },
    async Migrar(qs) { return await methods.Get("SubAccount/Migrar" + useParamsJson(qs)); },
    async GetAll() {
        const result = await SubAccountService.Get();
        if (result && (result.code === '1' || result.code === 1) && result.payload) {
            const data = JSON.parse(result.payload);
            await db.transaction('rw', db.subAccount, async () => {
                await db.subAccount.clear();
                if (Array.isArray(data) && data.length > 0) {
                    await db.subAccount.bulkPut(data);
                }
            });
            return true;
        } else if (result && (result.code === '0' || result.code === 0)) {
            await db.subAccount.clear();
            return true;
        }
        return false;
    }

};

export default SubAccountService;